import { useAtomValue, useSetAtom } from "jotai";
import { useEffect, useMemo } from "react";

import { MicroCmsImage } from "@/components/MicroCmsImage";
import {
  characterMotionAtom,
  characterSrcAtom,
  clientConfigAtom,
} from "@/utils/atoms";

type Props = {
  imageLoaded: boolean;
  handleImageLoad: () => void;
};

export function Character({
  imageLoaded,
  handleImageLoad,
}: Props): JSX.Element {
  const client = useAtomValue(clientConfigAtom);
  const characterMotion = useAtomValue(characterMotionAtom);
  const characterSrc = useAtomValue(characterSrcAtom);
  const setCharacterSrc = useSetAtom(characterSrcAtom);

  useEffect(() => {
    const imageSources: {
      [key in typeof characterMotion]: string | undefined;
    } = {
      attention: client.character.attention,
      happy: client.character.happy,
      talk: client.character.talk,
      respectful: client.character.respectful,
      greeting: client.character.greeting,
      normal: client.character.normal,
    };

    const keys = Object.keys(imageSources) as (keyof typeof imageSources)[];
    const randomKey = keys[Math.floor(Math.random() * keys.length)];
    const src = imageSources[randomKey] || "";

    setCharacterSrc(src);
  }, [client.character, setCharacterSrc]);

  const imageComponent = useMemo(
    () => (
      <MicroCmsImage
        src={characterSrc}
        format="webp"
        imageLoaded={imageLoaded}
        handleImageLoad={handleImageLoad}
        style={{
          top:
            client.characterPosition !== undefined &&
            client.characterPosition > 0
              ? `-${client.characterPosition}px`
              : "",
        }}
      />
    ),
    [imageLoaded, handleImageLoad, characterSrc, client.characterPosition],
  );

  return imageComponent;
}
